import { TransactionEntryCategoryFieldsFragment } from '../../graphql/generated';
import { formatSupercategory } from './formatSupercategory';

export const buildBaseCategoryGroups = (
    categories: TransactionEntryCategoryFieldsFragment[]
) => {
    const categoryGroups: Record<
        string,
        {
            label: string;
            parent: string;
            transactionEntryCategories: TransactionEntryCategoryFieldsFragment[];
        }
    > = {};
    const supercategoryGroups: Record<
        string,
        {
            label: string;
            transactionEntryCategories: TransactionEntryCategoryFieldsFragment[];
        }
    > = {};

    categories.forEach((category) => {
        const categoryGroupName = category.categoryGroup.name;
        const supercategory = category.categoryGroup.supercategory;

        if (!categoryGroups[categoryGroupName]) {
            categoryGroups[categoryGroupName] = {
                label: categoryGroupName,
                parent: formatSupercategory(supercategory),
                transactionEntryCategories: [],
            };
        }

        if (!supercategoryGroups[supercategory]) {
            supercategoryGroups[supercategory] = {
                label: formatSupercategory(supercategory),
                transactionEntryCategories: [],
            };
        }

        supercategoryGroups[supercategory].transactionEntryCategories.push(
            category
        );
        categoryGroups[categoryGroupName].transactionEntryCategories.push(
            category
        );
    });

    // Sort options alphabetically in each group
    Object.values(categoryGroups).forEach((group) => {
        group.transactionEntryCategories.sort((a, b) =>
            a.name.localeCompare(b.name)
        );
    });

    return { categoryGroups, supercategoryGroups };
};
